import React, { useState, useEffect } from 'react';
import { APP_VERSION, APP_BUILD, checkAppVersion, storeAppVersion, getInstallType } from '../utils/version';

const VersionBadge = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [versionInfo, setVersionInfo] = useState(null);
  const [installType, setInstallType] = useState('browser');

  useEffect(() => {
    const info = checkAppVersion();
    setVersionInfo(info);
    setInstallType(getInstallType());
    
    if (info.isUpdate) {
      storeAppVersion();
    }
  }, []);

  const shouldShow = installType === 'pwa' || installType === 'ios-standalone';
  if (!shouldShow) return null;

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="fixed bottom-4 right-4 z-40 flex flex-col items-end gap-2">
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="bg-gray-800/80 hover:bg-gray-700 text-white text-xs px-3 py-1.5 rounded-full backdrop-blur-sm transition"
      >
        v{APP_VERSION}
      </button>
      
      {showDetails && (
        <div className="bg-gray-900 text-white text-xs rounded-lg shadow-xl p-4 w-64">
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-400">Version</span>
              <span className="font-mono">v{APP_VERSION}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Build</span>
              <span className="font-mono">{APP_BUILD}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Installed</span>
              <span className="capitalize">{installType}</span>
            </div>
            
            {versionInfo?.isUpdate && (
              <div className="bg-yellow-500/20 border border-yellow-500/30 rounded p-2 text-yellow-400 text-center">
                🔄 Updated from v{versionInfo.stored}
              </div>
            )}
            
            <button 
              onClick={handleRefresh}
              className="w-full mt-2 py-2 bg-blue-600 hover:bg-blue-700 rounded text-white text-sm font-medium transition"
            >
              🔄 Refresh App
            </button>
            
            <button 
              onClick={() => setShowDetails(false)}
              className="w-full text-gray-400 hover:text-white text-center text-[10px] transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VersionBadge;
